import { atom } from "jotai";

/**
 * Set when a dynamic-import/chunk load fails because this tab is running an
 * older deploy than what's live at origin. Drives the OutOfSyncModal, which
 * lets the user save unsaved work before reloading. See
 * services/chunkLoadRecovery.ts.
 */
export const outOfSyncAtom = atom(false);
